import React, { Component } from "react";
import { Redirect } from "react-router-dom";

import PropTypes from "prop-types";

/**
 * This HOC redirects a user to home page if they hit a URL in
 * form process that isn't ready.
 * The client of this HOC would have to specify the boolean for
 * redirectToHomePage prop
 *
 */
export default function(ClientComponent) {
  return class RedirectToHomePage extends Component {
    static propTypes = {
      redirectToHomePage: PropTypes.bool
    };

    render() {
      return this.props.redirectToHomePage ? (
        <Redirect to={"/"} />
      ) : (
        <ClientComponent {...this.props} />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/withRedirectToHomePage.js